import { Route, RouteProps } from "react-router";

export const GuardRoute = ({
  ...routeProps
}: RouteProps): JSX.Element | null => {
  return <Route {...routeProps} />;
};
